<template>
  <!-- Use mouseup.stop to prevent SideLeft/deselectAllSlides function listens to MouseEvent('mouseup'). -->
  <div
    class="aha-right-nav"
    @mouseup.stop
    :class="{
      'powerpoint-addin-sticky': isEnableAddinPowerpoint && rightNavActiveTab
    }"
  >
    <div
      v-for="tab in rightNavAllTabs"
      :key="tab.name"
    >
      <div class="aha-nav-button-container">
        <aha-nav-button
          class="w-full"

          :active="rightNavActiveTab === tab.name"
          :disabled="isTabDisabled(tab.name)"
          name="right_nav_button"
          v-aha-emit-action="{ user_input: tab.name }"
          @click="activeTab(tab.name)"
          :iconName="tab.icon"
          :icon-width="tab.iconWidth"
          :icon-height="tab.iconHeight"

          :label="$i18nPresenter.t(tab.name)"
          :lang="getPresenterLocale"
        />
      </div>

      <div
        v-if="isRightNavDividerVisible(tab.name)"
        class="right-nav__divider-wrapper"
      >
        <div class="right-nav__divider"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import utils from '@/util'
import { EVENT_CATEGORIES_BY_ROUTE_NAME } from '@/constant/routes'

export default {
  props: {
    oneInSelectedSlidesHasAudio: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    ...mapGetters('rightNav', ['rightNavTabNames', 'rightNavAllTabs', 'rightNavActiveTab', 'isAudioTabDisabled']),
    ...mapGetters('slideType', ['isSlideTypeNoAudio']),
    ...mapGetters('featureToggles', ['canUseAIImprovingSlideContent']),
    ...mapGetters(['selectedSlides', 'getPresenterLocale']),

    ...mapState({
      slideActive: (state) => state.slideActive,
      selectedSlideIds: (state) => state.selections.selectedSlideIds,
      presentation: (state) => state.presentation,
      currentUser: (state) => state.currentUser,
      isEnableAddinPowerpoint: (state) => state.isEnableAddinPowerpoint,
    }),

    isMultipleSlidesSelected() {
      return this.selectedSlideIds.length > 1
    },

    isSlideNotCreated() {
      return !this.slideActive || (this.slideActive && !this.slideActive.id)
    },

    isTabDisabled() {
      return (tabName) => {
        const tabsRequiringSlideType = [this.rightNavTabNames.AUDIO, this.rightNavTabNames.DESIGN]
        const isTabAudio = tabName === this.rightNavTabNames.AUDIO
        const isTabContent = tabName === this.rightNavTabNames.CONTENT

        const isTabRequiringSlideTypeButHasNoSlideType = tabsRequiringSlideType.includes(tabName) &&
          !this.slideActive.type
        const isTabAudioDisabledWhenMultipleSlidesSelected = isTabAudio &&
          this.isMultipleSlidesSelected && this.isAudioTabDisabled
        const isTabAudioDisabledForSingleSlideWithNoAudio = isTabAudio &&
          !this.isMultipleSlidesSelected && this.isSlideTypeNoAudio
        const isTabContentWhenMultipleSlidesSelected = isTabContent && this.isMultipleSlidesSelected

        return isTabRequiringSlideTypeButHasNoSlideType ||
              isTabAudioDisabledWhenMultipleSlidesSelected ||
              isTabAudioDisabledForSingleSlideWithNoAudio ||
              isTabContentWhenMultipleSlidesSelected
      }
    },

    isRightNavDividerVisible() {
      const tabsWithDivider = [this.rightNavTabNames.AI, this.rightNavTabNames.AUDIO]
      return (tabName) => tabsWithDivider.includes(tabName)
    },
  },
  watch: {
    oneInSelectedSlidesHasAudio(value) {
      this.setAudioTabDisabled(!value)
    },
  },

  methods: {
    ...mapActions('rightNav', ['setRightNavActiveTabAction', 'setAudioTabDisabled']),

    activeTab(tabName) {
      if (this.isTabDisabled(tabName)) return

      this.setRightNavActiveTabAction(tabName)

      if (tabName === this.rightNavTabNames.AI) {
        utils.trackGA4AndMixpanel('Open AI Panel', {
          eventAction: 'Open AI Panel',
          eventCategory: EVENT_CATEGORIES_BY_ROUTE_NAME[this.$route.name],
          slideId: this.slideActive && this.slideActive.id,
          presentationId: this.presentation.id,
          userId: this.currentUser.id,
          touch_point: 'Right nav',
        })
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.aha-right-nav {
  @apply bg-base-0 h-full pt-4 overflow-y-auto text-secondary-100 border border-base-30;
  box-shadow: 0px 10px 38px 0px #525F7F14;
  width: 98px;
  min-width: 98px;
  z-index: 1;
      /*
   * Only apply custom styles for special cases that don't override
   * the default aha-nav-button styles
   */
    .aha-nav-button-container {
    @apply my-0 mx-1 mb-2;
  }
  .right-nav__divider-wrapper {
    @apply w-full my-3;
    .right-nav__divider {
      @apply bg-secondary-20 h-0.25 my-0 mx-auto;
      width: 40px;
    }
  }
  &.powerpoint-addin-sticky {
    position: fixed;
    right: 0;
    z-index: 2;
    overflow-x: hidden;
  }
}
</style>
